// Contact.jsx

import React from "react";
import { Link } from "react-router-dom";
import "../styles/contact.css";

import logo from "../pictures/logonav.png";
import veldfooter from "../pictures/logonav.png";
import contactBanner from "../pictures/ss3.jpeg";

function Contact() {
  return (
    <div className="contact-page">

      {/* NAVBAR */}
      <nav className="contact-nav">

        <Link to="/" className="contact-logo-link">
          <div className="contact-logo-wrap">
            <img
              src={logo}
              alt="Company Logo"
              className="contact-logo-img"
            />
          </div>
        </Link>

        <div className="contact-nav-links">
          <Link to="/">Home</Link>
          <Link to="/products">Products</Link>
          <Link to="/contact" className="active-link">
            Contact
          </Link>
        </div>

      </nav>

      {/* HERO */}
      <section
        className="contact-hero"
        style={{ backgroundImage: `url(${contactBanner})` }}
      >

        <div className="contact-overlay"></div>

        <div className="contact-hero-content">

          <span className="contact-tag">
            HAVE AN QUERY ?
          </span>

          <h1 className="contact-heading">
            CONTACT
            <span>VELD </span>
          </h1>

          <p className="contact-subtext">
            Expanding premium flooring and industrial rubber solutions
            across Europe and the Middle East through our trusted global
            branches.
          </p>

        </div>

      </section>

 <a id="conactmsg"
                href="mailto:malabarmatseurope@gmail.com"
                className="branch-contact-btn"
              >
                SEND US A MESSAGE
              </a>

      {/* MAIN SECTION */}
      <section className="contact-main-section">

        <div className="contact-left">

          <span className="contact-eyebrow">
            OUR GLOBAL BRANCHES
          </span>

          <h2 className="contact-title">
            WORLDWIDE
            <span>NETWORK</span>
          </h2>

          <p className="contact-description">
            Premium industrial and commercial flooring solutions
            engineered for durability, safety, comfort, and
            high-performance environments.
          </p>

          <div className="global-branches-grid">

            {/* Netherlands */}
            <div className="branch-card">

              <div className="branch-top-line"></div>

              <span className="branch-country">
                NETHERLANDS
              </span>

              <h3>
                Indo-Euro Rubber Solutions Netherlands
              </h3>

              <p>
                Bosboomtousaintstraat 12 <br />
                9721RH Groningen
              </p>

              <a
                href="tel:+31637546423"
                className="branch-contact-btn"
              >
                +31 6 37546423
              </a>

            </div>

            {/* Germany */}
            <div className="branch-card dark-branch">

              <div className="branch-top-line"></div>

              <span className="branch-country">
                GERMANY
              </span>

              <h3>
                Indo-Euro Rubber Solutions
              </h3>

              <p>
                Müllerstr. 30 <br />
                12207 Berlin, Germany
              </p>

              <a
                href="tel:+4917660373098"
                className="branch-contact-btn"
              >
                +49 176 60373098
              </a>

            </div>

            {/* UAE */}
            <div className="branch-card">

              <div className="branch-top-line"></div>

              <span className="branch-country">
                UAE
              </span>

              <h3>
                Landlord General Maintenance LLC
              </h3>

              <p>
                P. O. Box 35818 <br />
                Abu Dhabi, UAE
              </p>

              <a
                href="mailto:malabarmatseurope@gmail.com"
                className="branch-contact-btn"
              >
                SEND MESSAGE
              </a>

            </div>

          </div>

        </div>

      </section>

      {/* FOOTER */}
      <footer className="contact-footer">

        <div className="contact-footer-inner">

          <div className="contact-footer-brand">

            <Link to="/" className="contact-logo-link">
              <div className="contact-logo-wrap footer-logo-wrap">

                <img
                  src={veldfooter}
                  alt="Footer Logo"
                  className="contact-logo-img"
                />

              </div>
            </Link>

            <p>
              Premium industrial flooring and rubber matting solutions
              engineered for durability, comfort, and performance.
            </p>

          </div>

          <div className="contact-footer-links">

            <h4>Quick Links</h4>

            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>

          </div>

          <div className="contact-footer-links">

            <h4>Products</h4>

            <ul>
              <li><Link to="/products">Industrial Mats</Link></li>
              <li><Link to="/products">Gym Flooring</Link></li>
              <li><Link to="/products">Anti Fatigue Mats</Link></li>
              <li><Link to="/products">Commercial Flooring</Link></li>
            </ul>

          </div>

        </div>

        <div className="contact-footer-bottom">
          <span>
            © {new Date().getFullYear()} VELD floorings. All Rights Reserved.
          </span>
        </div>

      </footer>

    </div>
  );
}

export default Contact;